<template>
    <div>
      <v-card flat class="compact-formComplete">
        <v-container style="text-align: center">
          <v-icon size="100" color="red">cancel</v-icon>
        </v-container>
        <v-container style="text-align: center">
          <h2
            style="color:red"
          >
            Payment Unsuccessful
          </h2>
          <h3
          pt-3
            :style="{
              color: $store.state.currentOrg.orderSecondaryColour
                ? $store.state.currentOrg.orderSecondaryColour
                : $store.state.currentOrg.secondaryColour,
            }"
          >
            There has been an issue in processing your payment.
          </h3>
          <br />

        </v-container>
      </v-card>
    </div>
</template>
<script>
export default {
}
</script>